import detectIsMobile from 'is-mobile';
import env from '@in3d/environment';

export const isMobile = () => {
  if ('isMobile' in env) return env['isMobile'];
  return detectIsMobile({ featureDetect: true, tablet: true });
};
